(function () {
  "use strict";

  angular.module("appback").controller("ExportDashboardController", ExportDashboardController);

  ExportDashboardController.$inject = ["$http", "$timeout"];

  // Pestañas Resumen, Países, Distribuidores y Productos del dashboard
  // (backend/views/site/roles/admin.php). Los datos salen de
  // backend\controllers\DashboardController::actionExportKpis() y
  // ::actionExportPais(), calculados en common\helpers\ExportKpiHelper.

  var CLASIFICACIONES = {
    proteger: { label: "Proteger y escalar", css: "badge-trend-positive" },
    pricing: { label: "Revisar pricing", css: "badge-trend-negative" },
    desarrollar: { label: "Desarrollar", css: "badge-soft" },
    cuestionar: { label: "Cuestionar prioridad", css: "badge-trend-negative" },
    controlar: { label: "Mantener / controlar", css: "badge-neutral" },
    sin_venta: { label: "Proyectado sin venta", css: "badge-warning-soft" },
    sin_dato: { label: "Sin dato operativo", css: "badge-neutral" },
  };

  var ESTADOS_DISTRIBUIDOR = {
    activo: { label: "Activo", css: "badge-trend-positive" },
    vigilar: { label: "Vigilar", css: "badge-warning-soft" },
    riesgo: { label: "En riesgo", css: "badge-trend-negative" },
    inactivo: { label: "Sin pedidos recientes", css: "badge-neutral" },
  };

  function ExportDashboardController($http, $timeout) {
    var vm = this;

    vm.filtros = { anio: "", desde: "", hasta: "", region: "", pais: "" };
    vm.opciones = { anios: [], meses: [], regiones: [], paises: [] };
    vm.data = null;
    vm.loading = false;
    vm.error = "";
    vm.mostrarComposicion = false;

    vm.ficha = null;
    vm.fichaPaisId = "";
    vm.fichaLoading = false;

    vm.load = load;
    vm.reset = reset;
    vm.exportCsv = exportCsv;
    vm.loadFicha = loadFicha;
    vm.verFicha = verFicha;
    vm.eur = eur;
    vm.eurCorto = eurCorto;
    vm.pct = pct;
    vm.pp = pp;
    vm.signo = signo;
    vm.clasificacion = clasificacion;
    vm.estadoDistribuidor = estadoDistribuidor;
    vm.paisesDeRegion = paisesDeRegion;
    vm.maxVentasPais = maxVentasPais;
    vm.anchoBarra = anchoBarra;
    vm.conVenta = conVenta;
    vm.conProyeccion = conProyeccion;

    var mensualChart = null;
    var fichaChart = null;

    load();

    function load() {
      vm.loading = true;
      vm.error = "";
      return $http
        .get("/backend/dashboard/export-kpis", { params: vm.filtros, ignoreLoadingBar: true })
        .then(function (res) {
          vm.data = res.data;
          vm.opciones = res.data.opciones;
          // El backend normaliza los filtros (año por defecto, último mes
          // con ventas...): se reflejan en los selects.
          vm.filtros.anio = res.data.filtros.anio;
          vm.filtros.desde = res.data.filtros.desde;
          vm.filtros.hasta = res.data.filtros.hasta;
          // El canvas está dentro de un ng-if: hasta el siguiente digest no
          // existe en el DOM.
          $timeout(function () {
            renderMensualChart(res.data.mensual);
          });

          var paises = res.data.paises || [];
          var sigueVisible = paises.some(function (p) {
            return p.id === vm.fichaPaisId;
          });
          if (!sigueVisible) {
            vm.fichaPaisId = paises.length ? paises[0].id : "";
          }
          loadFicha();
        })
        .catch(function () {
          vm.error = "No se han podido cargar los datos de exportación.";
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function reset() {
      vm.filtros = { anio: "", desde: "", hasta: "", region: "", pais: "" };
      load();
    }

    function loadFicha() {
      if (!vm.fichaPaisId) {
        vm.ficha = null;
        return;
      }
      vm.fichaLoading = true;
      $http
        .get("/backend/dashboard/export-pais", {
          params: { id: vm.fichaPaisId, anio: vm.filtros.anio, desde: vm.filtros.desde, hasta: vm.filtros.hasta },
          ignoreLoadingBar: true,
        })
        .then(function (res) {
          vm.ficha = res.data;
          $timeout(function () {
            renderFichaChart(res.data.mensual);
          });
        })
        .finally(function () {
          vm.fichaLoading = false;
        });
    }

    function verFicha(pais) {
      vm.fichaPaisId = pais.id;
      loadFicha();
    }

    function paisesDeRegion() {
      return vm.opciones.paises.filter(function (p) {
        return !vm.filtros.region || p.region === vm.filtros.region;
      });
    }

    function maxVentasPais() {
      if (!vm.data) {
        return 0;
      }
      return vm.data.paises.reduce(function (max, p) {
        return Math.max(max, p.real);
      }, 0);
    }

    // Ancho (%) de una barra horizontal relativa al máximo; se aplica con
    // ng-style porque es un dato por fila.
    function anchoBarra(valor, max) {
      return { width: (max > 0 ? Math.max(1, (valor / max) * 100) : 0) + "%" };
    }

    function conVenta(pais) {
      return pais.real > 0;
    }

    function conProyeccion(pais) {
      return pais.proyeccion !== null;
    }

    function clasificacion(key) {
      return CLASIFICACIONES[key] || CLASIFICACIONES.sin_dato;
    }

    function estadoDistribuidor(key) {
      return ESTADOS_DISTRIBUIDOR[key] || ESTADOS_DISTRIBUIDOR.activo;
    }

    function eur(n) {
      if (n === null || n === undefined || isNaN(n)) {
        return "N/D";
      }
      return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
    }

    function eurCorto(n) {
      if (n === null || n === undefined || isNaN(n)) {
        return "N/D";
      }
      return new Intl.NumberFormat("es-ES", { notation: "compact", maximumFractionDigits: 1 }).format(n) + " €";
    }

    function pct(n) {
      if (n === null || n === undefined || isNaN(n)) {
        return "N/D";
      }
      return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 1 }).format(n) + "%";
    }

    function signo(n) {
      return n > 0 ? "+" : "";
    }

    function pp(n) {
      if (n === null || n === undefined || isNaN(n)) {
        return "N/D";
      }
      return signo(n) + new Intl.NumberFormat("es-ES", { maximumFractionDigits: 2 }).format(n) + " pp";
    }

    function exportCsv() {
      if (!vm.data) {
        return;
      }
      var cabecera = ["País", "Región", "Real periodo", "Margen %", "Año anterior (periodo)", "Var. %", "Proyección", "Obj. lineal YTD", "Gap", "Clasificación", "Estado dato", "Comentario"];
      var filas = vm.data.paises.map(function (p) {
        return [p.nombre, p.region, p.real, p.margen, p.previo, p.yoy, p.proyeccion, p.objLineal, p.gap, clasificacion(p.clasificacion).label, p.estadoDato, p.comentario];
      });
      var csv = [cabecera]
        .concat(filas)
        .map(function (fila) {
          return fila
            .map(function (valor) {
              var texto = valor === null || valor === undefined ? "" : String(valor);
              return '"' + texto.replace(/"/g, '""') + '"';
            })
            .join(";");
        })
        .join("\r\n");

      var blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
      var link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "exportaciones-" + vm.data.filtros.anio + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }

    function cssVar(name, fallback) {
      var value = getComputedStyle(document.documentElement).getPropertyValue(name);
      return (value && value.trim()) || fallback;
    }

    function lineChart(existing, canvasId, serie) {
      var canvas = document.getElementById(canvasId);
      if (!canvas || typeof Chart === "undefined" || !serie) {
        return existing;
      }
      var datasets = [
        {
          label: String(serie.anio),
          data: serie.actual,
          borderColor: cssVar("--color-primary", "#091426"),
          backgroundColor: cssVar("--color-primary", "#091426"),
          tension: 0.25,
          borderWidth: 2,
          pointRadius: 3,
        },
        {
          label: String(serie.anio - 1),
          data: serie.anterior,
          borderColor: cssVar("--color-surface-tint", "#545f73"),
          backgroundColor: cssVar("--color-surface-tint", "#545f73"),
          borderDash: [6, 4],
          tension: 0.25,
          borderWidth: 2,
          pointRadius: 2,
        },
      ];

      // Si el ng-if ha recreado el canvas, el gráfico anterior apunta a uno
      // que ya no está en el DOM.
      if (existing && existing.canvas !== canvas) {
        existing.destroy();
        existing = null;
      }

      if (existing) {
        existing.data.labels = serie.labels;
        existing.data.datasets = datasets;
        existing.update();
        return existing;
      }

      return new Chart(canvas.getContext("2d"), {
        type: "line",
        data: { labels: serie.labels, datasets: datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: "index", intersect: false },
          plugins: {
            legend: { position: "bottom", labels: { boxWidth: 16, font: { size: 11 } } },
            tooltip: {
              callbacks: {
                label: function (ctx) {
                  return ctx.dataset.label + ": " + eur(ctx.parsed.y);
                },
              },
            },
          },
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 11 } } },
            y: {
              beginAtZero: true,
              ticks: {
                font: { size: 11 },
                callback: function (value) {
                  return eurCorto(value);
                },
              },
            },
          },
        },
      });
    }

    function renderMensualChart(serie) {
      mensualChart = lineChart(mensualChart, "exportMensualChart", serie);
    }

    function renderFichaChart(serie) {
      fichaChart = lineChart(fichaChart, "exportFichaChart", serie);
    }
  }
})();
